<template>
    <auth-layout
        :image="4"
        :byword="isAdminRegisteringPhysician ? '' : $t('pages.auth.signup.steps.schedule.byword')"
        :progress="progress"
    >
        <common-content-wrapper width="small">
            <common-page-header
                :heading="$t('pages.auth.signup.steps.schedule.heading')"
                :content="headingContent()"
            ></common-page-header>
        </common-content-wrapper>

        <common-content-wrapper width="large">
            <schedule-form
                :locations="locations"
                :dayFrom="7"
                :dayTo="19"
                @show-review-changed="showReviewChanged"
                @show-start-changed="showStartDateChanged"
                @sent="detectNextStep()"
            ></schedule-form>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import SignupPageMixin from 'mixins/SignupPageMixin'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    import AdminRegistersPhysicianMixin from 'mixins/AdminRegistersPhysicianMixin'
    import AuthLayout from 'components/layouts/AuthLayout'
    import ScheduleForm from 'components/forms/AuthSignupScheduleForm'
    import UsersAPI from 'api/UsersAPI'
    import UserRolesEnum from 'enums/UserRolesEnum'

    export default {
        mixins: [SignupPageMixin, ScreenSizeDetectionMixin, AdminRegistersPhysicianMixin],

        components: {
            AuthLayout,
            ScheduleForm,
        },

        data() {
            return {
                showReview: false,
                showStartDate: false,
            }
        },

        computed: {
            locations() {
                return [
                    { label: 'Main', value: '0' },
                    ...this.$auth.getPractice().locations.map((location) => ({
                        label: location.name,
                        value: location.id,
                    })),
                ]
            },
        },

        methods: {
            detectNextStep() {
                const loggedInUser = this.$auth.getUser()
                const activeMember = this.$auth.getActiveMember()

                if (loggedInUser.id !== activeMember.id) {
                    if (process.env.VUE_APP_ENV === 'production' && !activeMember.isNotificationSentOnRegister) {
                        UsersAPI.sendNewMemberRegisteredNotificationEmail(activeMember.id)
                    }
                } else {
                    if (process.env.VUE_APP_ENV === 'production' && !loggedInUser.isNotificationSentOnRegister) {
                        UsersAPI.sendNewMemberRegisteredNotificationEmail()
                    }
                }

                if (loggedInUser?.userRole?.name === UserRolesEnum.OFFICE_MANAGER.NAME) {
                    this.$router.push({ name: 'auth.signup.registerPhysicians' })
                    return
                }
                if (loggedInUser.id !== activeMember.id) {
                    this.$auth.setActiveMember(loggedInUser)
                    this.$router.push({ name: 'practice.members' })
                    return
                }
                this.goToNextStep()
            },

            headingContent() {
                if (this.showReview && !this.showStartDate) {
                    return this.$t('pages.auth.signup.steps.schedule.review_label')
                } else if (!this.showReview && this.showStartDate) {
                    return this.$t('pages.auth.signup.steps.schedule.start_date_label')
                } else {
                    return this.isAdminRegisteringPhysician
                        ? this.$t('pages.auth.signup.steps.schedule.admin_description', {
                              name: this.$auth.getActiveMember().firstName,
                          })
                        : this.$t('pages.auth.signup.steps.schedule.description')
                }
            },

            showReviewChanged(payload) {
                this.showReview = payload
            },

            showStartDateChanged(payload) {
                this.showStartDate = payload
            },
        },

        mounted() {
            this.headingContent()
        },
    }
</script>
